import basicRest from '../common/CommonRestFunctions'

const baseIncomeUrl = '/income'

export default {
  getIncomes () {
    return basicRest.executeBasicAxiosGet(baseIncomeUrl + '/list')
  },
  saveIncome (incomeInfo) {
    return basicRest.executeBasicAxiosPost(baseIncomeUrl + '/save', incomeInfo)
  },
  deleteIncome (id) {
    return basicRest.executeBasicAxiosRemove(baseIncomeUrl + `/${id}`)
  },
  filterIncomes (filters) {
    return basicRest.executeBasicAxiosPost(baseIncomeUrl + '/filter', filters)
  },
  filterItemsByCommodityId (filters) {
    return basicRest.executeBasicAxiosPost(baseIncomeUrl + '/find-by-commodity', filters)
  },
  getIncomeNumberList () {
    return basicRest.executeBasicAxiosGet(baseIncomeUrl + '/income-number-list')
  }
}
